export default function deletePlanReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'DELETE_PLAN_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'DELETE_PLAN_ERROR':
            return {...state, ...{error: action.error}};

        case 'DELETE_PLAN_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}